export default "__VITE_ASSET__Bqv71jRy__"